(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results-common/assets/javascripts/parsers/parse-results.js') >= 0) return;  svs.modules.push('/components/numbergames/results-common/assets/javascripts/parsers/parse-results.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let productMapping;
let parsePayout;
if (svs.isServer) {
  const path = require('path');
  parsePayout = require(path.join(__dirname, 'parse-payout.es6'));
  const trinidadCore = require('@svenskaspelab/trinidad-core').core;
  productMapping = trinidadCore.components.require('numbergames', 'product-mapping').productMapping;
} else {
  productMapping = svs.numbergames.productMapping;
  parsePayout = svs.numbergames.results_common.parsers.payout;
}
function parseResult() {
  var _parseProductResult$p;
  let result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const parseProductResult = {
    EUROJACKPOT: parseEurojackpotResult,
    KENO: parseKenoResult,
    JOKER: parseJokerResult,
    LOTTO: parseLottoResult,
    VIKINGLOTTO: parseVikingResult
  };
  const productId = productMapping.getProductId(result.productId);
  const parsedResult = ((_parseProductResult$p = parseProductResult[productId]) === null || _parseProductResult$p === void 0 ? void 0 : _parseProductResult$p.call(parseProductResult, result)) || result;
  return _objectSpread(_objectSpread({}, parsedResult), {}, {
    regCloseTime: result.regCloseTime,
    productDrawId: productMapping.getProductDrawId(result.productId),
    drawNumber: result.drawNumber,
    productId
  });
}
function parseEurojackpotResult(_ref) {
  let drawResult = _ref.drawResult,
    distribution = _ref.distribution,
    winningCountry = _ref.winningCountry;
  if (Array.isArray(drawResult)) {
    const _drawResult = _slicedToArray(drawResult, 2),
      numbers = _drawResult[0].numbers,
      numbersExtra = _drawResult[1].numbers;
    return {
      winningCountry,
      correctRow: {
        numbers,
        numbersExtra
      },
      payout: {
        productId: productMapping.CONSTANTS.EUROJACKPOT,
        distribution: parsePayout.parseInternationalDistribution(...distribution)
      }
    };
  }
}
function parseKenoResult(_ref2) {
  let numbers = _ref2.numbers,
    _ref2$kungKenoNumber = _ref2.kungKenoNumber,
    kungKenoNumber = _ref2$kungKenoNumber === void 0 ? [] : _ref2$kungKenoNumber,
    distributionRegular = _ref2.distributionRegular,
    distributionKungKeno = _ref2.distributionKungKeno,
    totalPayout = _ref2.totalPayout,
    totalWinners = _ref2.totalWinners,
    topWin = _ref2.topWin;
  if (Array.isArray(distributionRegular) && Array.isArray(distributionKungKeno)) {
    const productId = 'KENO';
    distributionRegular = distributionRegular.map(dist => _objectSpread(_objectSpread({}, dist), {}, {
      productId,
      payoutType: 'regular',
      type: dist.id
    }));
    distributionKungKeno = distributionKungKeno.map(dist => _objectSpread(_objectSpread({}, dist), {}, {
      productId,
      payoutType: 'extra',
      type: dist.id
    }));
    return {
      correctRow: {
        numbers,
        kungKenoNumber: kungKenoNumber[0]
      },
      payouts: distributionRegular.concat(distributionKungKeno),
      totalPayout,
      totalWinners,
      topWin
    };
  }
}
function parseJokerResult(_ref3) {
  let _ref3$drawResult = _ref3.drawResult,
    drawResult = _ref3$drawResult === void 0 ? {} : _ref3$drawResult,
    distribution = _ref3.distribution;
  return {
    correctRow: {
      numbers: drawResult.numbers
    },
    payout: {
      distribution
    }
  };
}
function parseLottoResult(result) {
  return {
    lotto1: getLottoResultByType(1, result),
    lotto2: getLottoResultByType(2, result)
  };
}
function getLottoResultByType(type, _ref4) {
  let drawResult = _ref4.drawResult,
    distribution = _ref4.distribution;
  if (Array.isArray(drawResult) && Array.isArray(distribution)) {
    const dist = distribution.find(dist => dist.type === type);
    const _drawResult$find = drawResult.find(drawRes => drawRes.type === type),
      drawNumbers = _drawResult$find.drawNumbers;
    const _drawNumbers = _slicedToArray(drawNumbers, 2),
      numbers = _drawNumbers[0].numbers,
      numbersExtra = _drawNumbers[1].numbers;
    return {
      type,
      correctRow: {
        numbers,
        numbersExtra
      },
      payout: _objectSpread({
        productId: productMapping.CONSTANTS.LOTTO,
        type
      }, parsePayout.parseLottoPayout({
        distribution: dist.distribution,
        millionRain: distribution.find(dist => dist.type === type + 2)
      }))
    };
  }
}
function parseVikingResult(_ref5) {
  let drawResult = _ref5.drawResult,
    distribution = _ref5.distribution,
    winningCountries = _ref5.winningCountries;
  if (Array.isArray(drawResult) && Array.isArray(drawResult[0].drawNumbers)) {
    const _drawResult$0$drawNum = _slicedToArray(drawResult[0].drawNumbers, 2),
      numbers = _drawResult$0$drawNum[0].numbers,
      numbersExtra = _drawResult$0$drawNum[1].numbers;
    return {
      winningCountries,
      correctRow: {
        numbers,
        numbersExtra
      },
      payout: {
        productId: productMapping.CONSTANTS.VIKINGLOTTO,
        distribution: parsePayout.parseInternationalDistribution(...distribution)
      }
    };
  }
}
if (svs.isServer) {
  module.exports = {
    parseResult
  };
} else {
  svs.numbergames.results_common.parsers.results = {
    parseResult
  };
}

 })(window);